import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangeDeletePriceGql } from '../bimWorkOrderChangePriceQueries';

export const useBimWorkOrderChangeDeletePrices = ({
    workOrderChangeId,
    checkedRows,
}: {
    workOrderChangeId: number;
    checkedRows: { workOrderChangePriceId: number | undefined; workOrderPriceId: number | undefined }[];
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(() => ({ workOrderChangeId, priceIds: checkedRows }), [checkedRows, workOrderChangeId]);

    const [deleteData, deleteStatus, deleteError, request, deleteSetData] = useRequest({
        requestId: 'bimWorkOrderChangeDeletePrices',
        withEffect: false,
        query: bimWorkOrderChangeDeletePriceGql,
    });

    const deleteHandler = useCallback(() => {
        dispatch(request(variables));
    }, [dispatch, request, variables]);

    return {
        deleteData: deleteData?.bimRemoveWorkOrderChangePrices,
        deleteStatus,
        deleteError,
        deleteSetData,
        deleteHandler,
    };
};
